export default "* Sanser\n* Bevægelser\n* Jagtteknik\n\n";